import { flattenDeep } from '@antv/util';

import { Image } from '../../../Image/Image';
import { NavigationElementMore } from '../NavigationElementMore/NavigationElementMore';
import type { NavigationSectionConfig } from '../NavigationSection/types';
import type { MainNavigationElementsClassNames, NavigationElementConfig } from './types';

export const shouldRenderNested = (section?: NavigationSectionConfig) => {
  return Boolean(section && (`renderContent` in section || section.top?.length || section.bottom?.length));
};

/** Whether this nav item's `exact` mode considers the current URL a full match for `element.to`. */
export const isNavExactMatch = (element: NavigationElementConfig, pathname: string, currentPath: string): boolean => {
  if (element.ignoreSearch) {
    return pathname === element.to;
  }
  if (element.allowQueryKey) {
    return currentPath.split(`?${element.allowQueryKey}=`)[0] === element.to;
  }
  return currentPath === element.to;
};

export const checkHasActive = (element: NavigationElementConfig, pathname: string): boolean => {
  if (!element.section) return false;

  if (`renderContent` in element.section) return Boolean(element.to && pathname.startsWith(element.to));

  const nestedElements = flattenDeep(
    (element.section.top || []).concat(element.section.bottom || []).map((section) => section.elements || [])
  );

  return nestedElements.some((nestedElement) => {
    return nestedElement.active || pathname.startsWith(nestedElement.to);
  });
};

export const getLayout = (element: NavigationElementConfig, classNames: MainNavigationElementsClassNames) => (
  <>
    {element.image && (
      <div className={classNames.elementImage}>
        {typeof element.image === 'string' ? <Image src={element.image} /> : element.image}
      </div>
    )}
    {(element.name || element.text) && <div className={classNames.elementTitle}>{element.name || element.text}</div>}
    <NavigationElementMore more={element.more} section={element.section} />
  </>
);
